/** Public auth URLs that must not bounce logged-out visitors to /login. */

function normalizePath (path) {
  return String(path || '').toLowerCase().replace(/\/+$/, '') || '/'
}

export function isSignupPath (path) {
  var p = normalizePath(path)
  return p === '/signup' || p === '/asgtg/signup'
}

export function isAsgtgSignupPath (path) {
  return normalizePath(path) === '/asgtg/signup'
}

export function isConnectInvitePath (path) {
  return /^\/connect\/invite\/[^/]+$/.test(normalizePath(path))
}

export function isPublicAuthPath (path) {
  var p = normalizePath(path)
  return p === '/login' || isSignupPath(path) || p === '/forgotpassword' || p === '/resetpassword' || p === '/verify-email' || isConnectInvitePath(path)
}



// WEBPACK FOOTER //
// ./src/utils/publicAuthRoutes.js